import { Expose } from "class-transformer";

export class UpdateDocumentationTypeDto {
  @Expose()
  name: string;
}
